module.exports = "<p>\r\n  add-asset-to-scene-help works!\r\n</p>\r\n"